import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import useStyles from './style';
import { Box, Grid } from '@material-ui/core';
import { getUId } from '../../../../utils/utility';
const DetailSubLayout = (props) => {
  const classes = useStyles();
  const uid = getUId(props)
  return (
    <Grid uid={uid} className={classes.GridRoot}>
      <Box className={classes.root}>
        <Box className='rightPanelAD'>
          <Placeholder name="vad-left-col" rendering={props.rendering} appConfig={props.appConfig} />
        </Box>
        <Box className='leftPanelAD'>
          <Placeholder name="vad-right-col" rendering={props.rendering} appConfig={props.appConfig} />
        </Box>
      </Box>
    </Grid>
  )
};

export default DetailSubLayout;
